module.exports = __webpack_public_path__ + "static/media/view-icon-active.a1e38e14.svg";